export default {
    url: '/player/:guid?viewOnly',
    template: '<scorm-player view-only="vm.viewOnly" scorm-submission="vm.scormSubmission"/>',
    resolve: {
        scormSubmission (ScormSubmissionResource, $stateParams) {
            return ScormSubmissionResource.get({
                guid: $stateParams.guid,
                expand: 'scorm, user.company',
                fallbackLanguage: $stateParams.fallbackLanguage
            }).$promise;
        }
    },
    controller (WindowConfirmService, scormSubmission, $stateParams, CompanyService) {
        if (scormSubmission.user.company.skin) {
            CompanyService.loadSkin(scormSubmission.user.company.skin);
        }

        this.scormSubmission = scormSubmission;
        this.viewOnly = $stateParams.viewOnly;
        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/scorm/do/index.js